import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { CONSENT_STORAGE_KEY } from '@app/pages/welcome-consent/welcome-consent.page';

/**
 * Guard that redirects to the welcome/consent screen if the user
 * has not yet accepted the required consent (tracking + AI).
 * 
 * Consent state is stored in localStorage (device-level) because
 * the user is not yet authenticated at this point.
 * 
 * On web platform, the consent screen is skipped (web has its own
 * cookie consent mechanisms).
 */
@Injectable({
  providedIn: 'root'
})
export class ConsentGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    // Skip consent screen on web — only required for native apps (iOS/Android)
    if (!Capacitor.isNativePlatform()) {
      return true;
    }

    const consent = localStorage.getItem(CONSENT_STORAGE_KEY);
    return consent ? true : this.router.createUrlTree(['/welcome']);
  }
}
